import { useChapterStore } from '../../../shared/store/useChapterStore';
import { useMissionStore } from '../../../shared/store/useMissionStore';
import { useMemo } from 'react';
import { CustomImage } from '@/components/CustomImage';
import { arrowChapterImg } from '@/components/Card/Chapter';
import { Enum_Bookmark_Category } from '@edwin-group/cj-graphql';
import TitleWithActions from '@/components/TitleWithActions';

export const Hero = () => {
  const chapter = useChapterStore((state) => state.chapter);
  const mission = useMissionStore((state) => state.mission);

  const imageSrc = chapter?.cover?.url;

  const heroImage = useMemo(() => {
    if (!imageSrc) return null;

    return (
      <div className="relative">
        <div className="h-full max-h-[477px] w-full max-w-[849px] overflow-hidden rounded-2xl">
          <CustomImage
            src={imageSrc}
            alt={chapter?.title || ''}
            className="!h-full !max-h-[477px] !w-full !max-w-[849px] object-cover"
          />
        </div>
        <img
          src={arrowChapterImg}
          alt="arrow content type"
          className="-bottom-5.5 absolute right-10 -translate-y-1/2"
        />
      </div>
    );
  }, [imageSrc, chapter?.title]);

  const chapterIndex = useMemo(() => {
    return mission?.chapters?.findIndex((c) => c?.uuid === chapter?.uuid) ?? 0;
  }, [mission?.chapters, chapter?.uuid]);

  const totalChapters = useMemo(() => {
    return mission?.chapters?.length;
  }, [mission?.chapters]);

  if (!chapter) return null;

  return (
    <>
      {!chapter?.classVideoUrl && heroImage}
      <div className="mt-sh-60">
        <h1 className="font-cadiz text-sh-28-32 font-bold">{mission?.roleModel}</h1>
        <TitleWithActions
          key={`${mission?.documentId}/${chapter?.uuid}`}
          textSize="text-sh-28-32"
          title={`Part ${chapterIndex + 1}/${totalChapters}: ${chapter?.title}`}
          entity={{
            ...chapter,
            chapterId: `${mission?.documentId}/${chapter?.uuid}`,
            missionSlug: mission?.slug || '',
            missionTrait: mission?.trait?.trait || '',
            missionTotalChapters: totalChapters,
            chapterIndex: chapterIndex,
          }}
          category={Enum_Bookmark_Category.Chapter}
          entityId={`${mission?.documentId}/${chapter?.uuid}`}
        />
        <p className="mt-2 text-base text-gray-600">{chapter?.description}</p>
      </div>
    </>
  );
};
